import { EntityStateKey, EntityStateValue, EntityStateViewName } from '@engoo/realtime-protocol/entityState';
import { IKeyPathViewElement } from '@engoo/realtime-protocol/keypath';
import { KeyPath } from 'app/models/entityStateSync/keypath';
import { Map, Record } from 'immutable';

export type IEntityStateKeyPathViewElement<T extends EntityStateViewName> = IKeyPathViewElement & { viewName: T; };

export type IKeyPathState<ViewName extends EntityStateViewName> = {
  [Key in EntityStateKey<ViewName>]: EntityStateValue<ViewName, Key> | undefined;
};

export type KeyPathState<ViewName extends EntityStateViewName> = Record<IKeyPathState<ViewName>>;

export class CompactVocabState extends Record<IKeyPathState<EntityStateViewName.CompactVocab>>({
  expandedWordId: undefined,
}) {}

export class CourseListingState extends Record<IKeyPathState<EntityStateViewName.CourseListing>>({
  expanded: undefined,
}) {}

export class LessonPageState extends Record<IKeyPathState<EntityStateViewName.LessonPage>>({
  expandedModal: undefined,
}) {}

export class VocabSentencesState extends Record<IKeyPathState<EntityStateViewName.VocabSentences>>({
  showAllSentences: undefined,
}) {}


export class ChatAttachmentState extends Record<IKeyPathState<EntityStateViewName.ChatAttachment>>({
  expandedAttachmentId: undefined,
}) {}

export type IKeyPathStateMap<ViewName extends EntityStateViewName> = Map<KeyPath, KeyPathState<ViewName>>;

export class KeyPathRootState extends Record<{
  [ViewName in EntityStateViewName]: IKeyPathStateMap<ViewName>;
}>({
  [EntityStateViewName.CompactVocab]: Map(),
  [EntityStateViewName.CourseListing]: Map(),
  [EntityStateViewName.LessonPage]: Map(),
  [EntityStateViewName.VocabSentences]: Map(),
  [EntityStateViewName.ChatAttachment]: Map(),
}) {}
